import { Icon } from '@iconify/react/dist/iconify.js';
import { Autocomplete, Box, createFilterOptions, FormControl, FormHelperText, FormLabel, TextField } from '@mui/material';


export default function CustomAutocomplete({ limitTags, width, key, values, onChange, error, data, title, required, disabled, labelName = 'name', valueName = 'id', placeholder, isOptional, style, padding, freeSolo = false, createRecord = false, noIcon = false, borderRadius = 12 }) {
    const filter = createFilterOptions();
    return (
        <>
            <FormControl variant="outlined" fullWidth={width ? false : true} error={error ? true : false} style={{ border: '1.5px solid #E6E6E6', borderRadius: 12, marginTop: 6, paddingBlock: 5, backgroundColor: disabled ? '#F5F5F5' : 'white' }}>
                {
                    title &&
                    <FormLabel style={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 12, marginBlock: 0, marginInline: 15, color: "#808588", justifyContent: "space-between", display: "flex" }}>
                        {title} {isOptional ? <span className="optional-label">Optional</span> : null}
                    </FormLabel>
                }
                <Autocomplete
                    size="small"
                    key={values === null ? 'empty' : values}
                    value={data.find(option => option?.[valueName] === values) || null}
                    required={required}
                    disabled={disabled}
                    options={data}
                    freeSolo={freeSolo}
                    getOptionLabel={(option, value) => {
                        if (option.inputValue) {
                            return option.inputValue;
                        }
                        // Regular option
                        return option?.[labelName] || values
                    }}
                    renderOption={(props, option) => (
                        <Box component="li" {...props} key={`${option?.[labelName]}`} style={{ backgroundColor: values === option?.[valueName] ? '#FDECEC' : 'white', borderRadius: 8, margin: 4 }}>
                            {option?.title || option?.[labelName]}
                        </Box>
                    )}
                    onClose={(event, reason) => {
                        if (reason === 'blur' || reason === 'escape') {
                            const inputValue = event?.target?.value || '';
                            const isExisting = data.some(option => option?.[labelName] === inputValue);
                            if (freeSolo && inputValue && !isExisting) {
                                onChange(event, inputValue);
                            }
                        }
                    }}
                    filterOptions={(options, params) => {
                        let filtered = filter(options, params);
                        const { inputValue } = params;
                        const normalizedInput = (inputValue || '').trim().toLowerCase();

                        // Only show "Record not found" when there are no matching options at all.
                        const hasFilteredMatch = filtered.some((option) => {
                            const optionLabel = (option?.[labelName] || '').toString().trim().toLowerCase();
                            return optionLabel !== '' && optionLabel.includes(normalizedInput);
                        });

                        if (freeSolo) {
                            if (normalizedInput !== '' && !hasFilteredMatch) {
                                filtered.push({
                                    inputValue,
                                    title: values === inputValue ? inputValue : `Record not found, add "${inputValue}"`,
                                });
                            }
                        } else {
                            if (normalizedInput !== '' && !hasFilteredMatch) {
                                filtered.push({
                                    inputValue,
                                    title: values === inputValue ? inputValue : `Record not found.`,
                                });
                            }
                        }

                        return filtered;
                    }}
                    forcePopupIcon={true}
                    isOptionEqualToValue={(option, value) => option?.[valueName] === value?.[valueName]} // Match by valueName
                    placeholder={placeholder}
                    onChange={(e, value) => { onChange(e, freeSolo ? value?.inputValue || value : value); }}
                    popupIcon={<i className="ri-arrow-down-s-line mx-2" style={{ color: "#101010", marginTop: values && title ? -0 : 0 }} />}
                    renderInput={(params) =>
                        <TextField {...params} placeholder={"Please Select"}
                            variant="standard"
                            error={error ? true : false}
                            sx={{
                                style,
                                border: "0px solid #A0A0A065",
                                borderRadius: borderRadius,
                                paddingBlock: title ? 0 : "10px",
                                paddingInline: 0.5,
                                backgroundColor: disabled ? '#F5F5F5' : 'white',
                                color: values === "" || values === undefined || values === null ? "#E6E6E6" : "inherit",
                                width: "100%",
                                "&:before": {
                                    border: '0px'
                                },
                                "&:after": {
                                    borderBottom: '0px'
                                },
                                '& .MuiInputBase-input::placeholder': {
                                    color: '#bdbdbd',
                                    opacity: 1, // otherwise firefox shows a lighter color
                                },
                            }}
                            InputProps={{
                                ...params.InputProps,
                                disableUnderline: true,

                            }}
                        />
                    }
                    sx={{
                        style,
                        "& .MuiInput-root.MuiInputBase-sizeSmall .MuiInput-input": {
                            paddingBlock: padding && padding,
                            paddingInline: "10px",
                            borderRadius: '5px'
                        },
                        backgroundColor: disabled ? '#F5F5F5' : 'white'
                    }}>
                </Autocomplete>

            </FormControl >
            {error && <FormHelperText className='d-flex align-items-center mx-0' sx={{ color: "#BA2727", marginTop: "8px" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error || ""}</FormHelperText>}
        </>
    );
}
